export default __webpack_public_path__ + "static/media/left-square-o.fffb3247.svg";